import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryLocation = fp.get('inventory.location');

export const getAll = createSelector(getInventoryLocation, fp.get('all'));

export const getAllValues = createSelector(getAll, fp.values);

export const getLocationForId = createSelector((_, id) => id, getAll, fp.get);

export const getIsFetching = createSelector(
  getInventoryLocation,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryLocation,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryLocation,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(
  getInventoryLocation,
  fp.get('saving')
);
export const getIsSaved = createSelector(getInventoryLocation, fp.get('saved'));
export const getSavingError = createSelector(
  getInventoryLocation,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(
  getInventoryLocation,
  fp.get('deleting')
);
export const getIsDeleted = createSelector(
  getInventoryLocation,
  fp.get('deleted')
);
export const getDeletingError = createSelector(
  getInventoryLocation,
  fp.get('deletingError')
);

export const getOrder = createSelector(getInventoryLocation, fp.get('order'));
